// extracted by mini-css-extract-plugin
export default {"form":"Checkout_form__fNwCk","control":"Checkout_control__Xf5xB","actions":"Checkout_actions__lhVqq","submit":"Checkout_submit__MW4OW","invalid":"Checkout_invalid__mWmSh"};